import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import './ComboCodeValidation.scss';

var ComboCodeValidation = /*#__PURE__*/function (_Component) {
  _inherits(ComboCodeValidation, _Component);

  function ComboCodeValidation() {
    _classCallCheck(this, ComboCodeValidation);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComboCodeValidation).apply(this, arguments));
  }

  _createClass(ComboCodeValidation, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        id: "combo-api-error",
        className: "cm-alert-danger",
        role: "alert"
      }, "We couldn't verify your address.");
    }
  }]);

  return ComboCodeValidation;
}(Component);

export { ComboCodeValidation as default };